import { render } from "./AnexosAmbiente.vue?vue&type=template&id=c7e5609c&ts=true"
import script from "./AnexosAmbiente.vue?vue&type=script&lang=ts"
export * from "./AnexosAmbiente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__